// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.btn[data-v-7442d410] {\n  padding: 9px 18px;\n  min-width: 92px;\n}", ""]);
// Exports
module.exports = exports;
